import { IMenu, MenuNameEnum } from 'shared/models/Menu'

const mapMenu = (menuItems: IMenu[]) => {
  let menu = menuItems

  menu = [
    {
      name: 'dashboard',
      displayName: 'Hjem',
      url: '/',
      menuId: 'board',
      menuItems: [],
    },
    ...menu,
  ]
  // Users without styreportal roles
  if (menu.length === 1) {
    menu.push({
      name: 'economy',
      displayName: 'Økonomi',
      url: '/okonomi/faktura',
      menuId: 'economy',
      menuItems: [],
      hidden: true,
    })
  }
  const economyIndex = menu.findIndex((x) => x.name === 'economy')
  if (economyIndex > -1) {
    menu[economyIndex].menuItems = menu[economyIndex].menuItems.filter(
      (y) =>
        y.name !== 'economy-invoiceapproval' &&
        y.name !== 'economy-invoicearchive'
    )
  }

  menu.push({
    name: MenuNameEnum.settings,
    displayName: 'Innstillinger',
    url: '/innstillinger',
    menuId: 'settings',
    hidden: true,
    menuItems: [],
  })

  return menu
}

const mapMenuAuditor = (menuItems: IMenu[]) => {
  if (!menuItems?.length) return []
  const menu = [
    {
      name: 'auditor',
      displayName: 'Revisor',
      url: '/revisor',
      menuId: 'revisor',
      menuItems: menuItems
        .map((x: IMenu) =>
          x.menuItems.map((y) => {
            y.displayName = mapDisplayNameAuditorAndJanitor(y.displayName)
            return y
          })
        )
        .flat(),
    },
  ]

  return menu
}

const mapMenuJanitor = (menuItems: IMenu[]) => {
  if (!menuItems?.length) return []
  const menu = [
    {
      name: 'janitor',
      displayName: 'Vaktmester',
      url: '/vaktmester',
      menuId: 'vaktmester',
      menuItems: menuItems
        .map((x: IMenu) =>
          x.menuItems.map((y) => {
            y.displayName = mapDisplayNameAuditorAndJanitor(y.displayName)
            return y
          })
        )
        .flat(),
    },
  ]

  return menu
}

const mapDisplayNameAuditorAndJanitor = (displayName: string) => {
  if (displayName === 'Oversikt') return 'Styre og komiteer'

  return displayName
}

export { mapMenu, mapMenuAuditor, mapMenuJanitor }
